type Gender = (typeof GENDERS)[number];

const GENDERS = ['1', '2'] as const;

export type { Gender };
export { GENDERS };
